import { Card } from 'reactstrap';
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import useJobSectors from '@/hooks/useJobSectors';
import styles from './styles.module.scss';
import TimeAgo from 'react-timeago';

export default function JobCard({
    title,
    description,
    salary_package,
    url_slug,
    addresses,
    published_at,
    categories,
    slider = false,
}) {
    const jobTypeCatId = "d0dac92e-18c8-4aca-818b-62daa86e3e59";
    const workTypeCatId = "53aa6eb5-9fcb-43a1-a6cb-db497c151bfd";
    const sectorCatId = "54182828-5365-45cf-ac98-4f86ec1177cd";
    const jobType = categories?.map((cat) => cat.id == jobTypeCatId && cat.values?.map((value) => value.name));
    const workType = categories?.map((cat) => cat.id == workTypeCatId && cat.values?.map((value) => value.name));
    const sectors = categories?.map((cat) => cat.id == sectorCatId && cat.values?.map((value, index) => <span key={index}>{value.name}{(index+1) < cat.values?.length && ", "}</span>));
    
    const sectorID = categories?.map((cat) => cat.id == sectorCatId && cat.values)?.filter(Boolean)?.[0]?.[0]?.id;
    const sector = useJobSectors().filter((sector) => sector.id === sectorID);

    const sectorIcon = sector?.pop()?.icon ?? null;

    const trimDescription = (htmlString) => {
        if (!htmlString) return "No description available.";
        const strippedString = htmlString.replace(/(<([^>]+)>)/gi, " ");
        return (
            strippedString.slice(0, 1000) + (strippedString.length > 1000 ? "..." : "")
        );
    };

    function formatSalaryRange(salaryString) {
        return salaryString.replace(/[\d.]+/g, (match) => {
            const number = parseFloat(match);
            if (isNaN(number)) return match;

            // Check if the original match included a decimal point
            const hasDecimal = match.includes('.');

            return new Intl.NumberFormat('en-GB', {
            // If the input had a decimal, show 2 places. If not, show 0.
                minimumFractionDigits: hasDecimal ? 2 : 0,
                maximumFractionDigits: 2
            }).format(number);
        });
    }

    return (
        <>
            <Card className={`${styles.root} ${slider ? styles.slider : ""} h-100 overflow-hidden w-100 border border-2 rounded-3`}>
                <a className="text-decoration-none h-100 p-4" href={`/jobs/${url_slug}`}>
                    <Card className="h-100 border-0 bg-transparent">
                        <div className={`h-100 d-flex flex-wrap justify-content-between gap-4 gap-md-5 ${slider && "flex-column"}`}>
                            <div className="col-md">
                                <div className="d-flex align-items-center gap-3 mb-3 mb-md-4">
                                    <figure className="d-flex align-items-center justify-content-center post-icon rounded-4 overflow-hidden m-0">
                                        <SourceFlowImage
                                            src={sectorIcon || "/site-assets/images/job-sector-default-icon-new2.png"}
                                            size="150x"
                                            alt={title}
                                        />
                                    </figure>
                                    <h5 className="post-title fw-semibold text-break m-0">{title}</h5>
                                </div>
                                <div>
                                    {!slider &&
                                        <p className="post-description text-muted m-0" dangerouslySetInnerHTML={{ __html: trimDescription(description) }} />
                                    }
                                    <div className="d-flex flex-wrap gap-1 gap-xl-2 mt-4">
                                        {addresses && <span className="badge rounded-pill text-white bg-black d-flex align-items-center gap-1"><i className="bi bi-geo-alt"></i> {addresses}</span>}
                                        {workType && <span className="badge text-wrap text-start rounded-pill border text-black">{workType}</span>}
                                        {sectors && <span className="badge text-wrap text-start rounded-pill border text-black">{sectors}</span>}
                                        {jobType && <span className="badge text-wrap text-start rounded-pill border text-black">{jobType}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className={`col d-flex align-items-end justify-content-between ${!slider && "col-md-auto flex-md-column align-items-md-end"}`}>
                                <div className={`d-flex flex-column align-items-start ${!slider && "align-items-md-end"}`}>
                                    {salary_package &&
                                        <span className="post-salary h4 m-0 mb-md-2 text-black">{formatSalaryRange(salary_package)}</span>
                                    }
                                    {published_at &&
                                        <span className="text-muted small"><i className="bi bi-clock me-1"></i> <TimeAgo date={published_at} /></span>
                                    }
                                </div>
                                <button type="button" className={`btn btn-primary btn-lg ${!slider && "mt-md-3"}`}>Apply Now</button>
                            </div>
                        </div>
                    </Card>
                </a>
            </Card>
        </>
    )
}
